module.exports = __webpack_public_path__ + "static/media/brand-icons.a046592b.woff";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/brand-icons.woff
// module id = 414
// module chunks = 0